module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "common-upload"
  }, [_c('Upload', {
    ref: "upload",
    attrs: {
      "type": "drag",
      "with-credentials": true,
      "headers": _vm.headers,
      "data": _vm.data,
      "show-upload-list": false,
      "multiple": _vm.num > 1,
      "default-file-list": _vm.defaultFileList,
      "on-success": _vm.onSuccess,
      "before-upload": _vm.beforeUpload,
      "accept": "image/*",
      "action": _vm.action
    }
  }, [_c('div', {
    staticStyle: {
      "padding": "10px 0"
    }
  }, [_c('Icon', {
    staticStyle: {
      "color": "#3399ff"
    },
    attrs: {
      "type": "ios-cloud-upload",
      "size": "52"
    }
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.text))])], 1)]), _vm._v(" "), _c('ul', _vm._l((_vm.fileList), function(item, index) {
    return _c('li', {
      staticClass: "upload-list"
    }, [(item && ((!item.status) || (item.status && item.status === 'finished'))) ? [_c('img', {
      attrs: {
        "src": item.url
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "upload-list-cover"
    }, [_c('Icon', {
      attrs: {
        "type": "ios-eye-outline"
      },
      nativeOn: {
        "click": function($event) {
          return _vm.handleView(index)
        }
      }
    }), _vm._v(" "), _c('Icon', {
      attrs: {
        "type": "ios-trash-outline"
      },
      nativeOn: {
        "click": function($event) {
          return _vm.handleRemove(item)
        }
      }
    })], 1)] : [(item.showProgress) ? _c('Progress', {
      attrs: {
        "percent": item.percentage,
        "hide-info": ""
      }
    }) : _vm._e()]], 2)
  }), 0), _vm._v(" "), (_vm.visible) ? _c('div', {
    staticClass: "carousel-mask",
    on: {
      "click": _vm.onCarouselClick
    }
  }) : _vm._e(), _vm._v(" "), (_vm.visible) ? _c('div', {
    staticClass: "carousel-wrapper"
  }, [_c('div', {
    staticStyle: {
      "position": "fixed",
      "z-index": "2002",
      "right": "40px",
      "top": "20px",
      "cursor": "hand"
    },
    on: {
      "click": _vm.onCarouselClick
    }
  }, [_c('Icon', {
    attrs: {
      "type": "close",
      "color": "white",
      "size": "40"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "carousel-content"
  }, [_c('Carousel', {
    attrs: {
      "autoplay": false,
      "autoplay-speed": 1000,
      "dots": "outside",
      "trigger": "click",
      "arrow": "always"
    },
    model: {
      value: (_vm.showIndex),
      callback: function($$v) {
        _vm.showIndex = $$v
      },
      expression: "showIndex"
    }
  }, _vm._l((_vm.fileList), function(file) {
    return _c('CarouselItem', {
      key: file.url,
      staticClass: "item"
    }, [_c('img', {
      staticStyle: {
        "width": "300px"
      },
      attrs: {
        "src": file.url,
        "alt": ""
      }
    })])
  }), 1)], 1)]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3bbb700b","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/multipleImageUpload.vue
// module id = 1749
// module chunks = 8